const Row = ({ k, v }) => (
  <tr className="border-b border-slate-100">
    <td className="w-40 py-1.5 pr-3 align-top text-[10px] uppercase tracking-wider text-slate-500">{k}</td>
    <td className="py-1.5 text-sm">{v ?? "—"}</td>
  </tr>
);

export const ExecutiveSummary = ({ model }) => (
  <ol className="list-decimal space-y-1.5 pl-5 text-sm leading-relaxed text-slate-800" data-testid="dd-exec-list">
    {(model.executive || []).map((x, i) => <li key={i}>{x}</li>)}
  </ol>
);

export const IdentitySection = ({ model, t }) => {
  const idn = model.identity || {};
  const c = idn.coordinates || {};
  return (
    <table className="w-full border-collapse" data-testid="dd-identity-table">
      <tbody>
        <Row k={t("dd.identity.number")} v={idn.number} />
        <Row k="TERYT" v={<span className="font-mono-data text-xs">{idn.full_id}</span>} />
        <Row k={t("dd.identity.gmina")} v={idn.gmina} />
        <Row k={t("dd.identity.powiat")} v={idn.powiat} />
        <Row k={t("dd.identity.woj")} v={idn.wojewodztwo} />
        {idn.area_m2 != null && <Row k={t("dd.identity.area")} v={`${idn.area_m2} m²`} />}
        {c.lat != null && <Row k={t("dd.identity.coords")} v={`${c.lat}, ${c.lng}`} />}
        {idn.address && <Row k={t("dd.identity.address")} v={idn.address} />}
      </tbody>
    </table>
  );
};

export const PlanningSection = ({ model, t }) => {
  const p = model.planning || {};
  const POG = { adopted: t("dd.pog.adopted"), draft: t("dd.pog.draft") };
  const MPZP = { existing: t("dd.mpzp.existing") };
  return (
    <table className="w-full border-collapse" data-testid="dd-planning-table">
      <tbody>
        <Row k={t("dd.planning.pog")} v={POG[p.plan_ogolny_status] || t("dd.unknown")} />
        <Row k="MPZP" v={MPZP[p.mpzp_status] || t("dd.mpzp.unknown")} />
        {p.mpzp_name && <Row k={t("dd.planning.mpzpName")} v={p.mpzp_name} />}
        {p.planning_zone && <Row k={t("dd.planning.zone")} v={p.planning_zone} />}
        <Row k={t("dd.planning.proceedings")} v={p.proceedings_status === "unknown" ? t("dd.unknown") : p.proceedings_status} />
        <Row k={t("dd.planning.consultations")} v={p.consultation_status === "unknown" ? t("dd.unknown") : p.consultation_status} />
      </tbody>
    </table>
  );
};

export const ChangesSection = ({ model, t }) => {
  const ch = model.changes || [];
  if (!ch.length) {
    return <div className="rounded-lg border border-slate-200 bg-slate-50 p-3 text-sm text-slate-600" data-testid="dd-changes-empty">{t("dd.noChanges")}</div>;
  }
  return (
    <ul className="space-y-2" data-testid="dd-changes-list">
      {ch.map((c, i) => (
        <li key={i} className="rounded-lg border border-slate-200 p-3 text-sm" data-testid={`dd-change-${i}`}>
          <b>{c.field}</b>: {c.previous_value} → {c.new_value}
          <span className="ml-2 text-xs text-slate-500">
            ({c.source_authority}, {(c.detected_at || "").slice(0, 10)})
          </span>
        </li>
      ))}
    </ul>
  );
};

export const SourceHealthSection = ({ model, t }) => {
  const sh = model.source_health || {};
  return (
    <div className="space-y-2" data-testid="dd-source-health">
      {sh.all_available && (
        <div className="rounded-lg border border-slate-200 bg-slate-50 p-3 text-sm text-slate-700" data-testid="dd-sources-ok">
          {t("dd.allAvailable")} {t("dd.dataAsOf")}: {(sh.data_as_of || "").slice(0, 10)}.
        </div>
      )}
      {(sh.unavailable || []).map((n) => (
        <div key={n} className="rounded-lg border border-dashed border-slate-400 p-3 text-sm" data-testid={`dd-source-down-${n}`}>
          <b>{t("dd.finding.unavailable")}</b> — {n}. {t("dd.unavailableNote")}
        </div>
      ))}
      {(sh.uncertain || []).map((n) => (
        <div key={n} className="rounded-lg border border-slate-300 p-3 text-sm text-slate-700" data-testid={`dd-source-uncertain-${n}`}>
          <b>{t("dd.finding.uncertain")}</b> — {n}.
        </div>
      ))}
    </div>
  );
};
